import _ from 'lodash';
import { formatFloat } from '../../../../utils';

export default {
    processor: {
        headerName: 'Processor',
        field: 'processor',
        minWidth: 150,
        flex: 1,
        type: 'string',
    },
    processor_number: {
        headerName: 'Processor#',
        field: 'processor_number',
        minWidth: 150,
        flex: 1,
        type: 'string',
    },
    processor_city: {
        headerName: 'City',
        field: 'processor_city',
        minWidth: 150,
        flex: 1,
        type: 'string',
    },
    processor_state: {
        headerName: 'State',
        field: 'processor_state',
        minWidth: 150,
        flex: 1,
        type: 'string',
    },
    count: {
        headerName: 'Loads',
        field: 'count',
        minWidth: 100,
        flex: 1,
        type: 'string',
    },
    amount: {
        headerName: 'Pickup (lbs)',
        field: 'amount',
        minWidth: 100,
        flex: 1,
        type: 'string',
        valueGetter: ({ row }) => formatFloat(row.amount),
    },
    category: {
        headerName: 'Category',
        field: 'category',
        minWidth: 150,
        flex: 1,
        type: 'string',
    },
    scc_average: {
        headerName: 'SCC',
        field: 'scc_average',
        minWidth: 100,
        flex: 1,
        type: 'string',
    },
    fat_average: {
        headerName: 'Fat %',
        field: 'fat_average',
        minWidth: 100,
        flex: 1,
        type: 'string',
        valueGetter: ({ row }) => formatFloat(row.fat_average),
    },
    fat_weight: {
        headerName: 'Fat (lbs)',
        field: 'fat_weight',
        minWidth: 100,
        flex: 1,
        type: 'string',
        valueGetter: ({ row }) => formatFloat(row.fat_weight),
    },
    protein_average: {
        headerName: 'Protein %',
        field: 'protein_average',
        minWidth: 100,
        flex: 1,
        type: 'string',
        valueGetter: ({ row }) => formatFloat(row.protein_average),
    },
    protein_weight: {
        headerName: 'Protein (lbs)',
        field: 'protein_weight',
        minWidth: 100,
        flex: 1,
        type: 'string',
        valueGetter: ({ row }) => formatFloat(row.protein_weight),
    },
    skim_weight: {
        headerName: 'SKIM (lbs)',
        field: 'skim_weight',
        minWidth: 100,
        flex: 1,
        type: 'string',
        valueGetter: ({ row }) => formatFloat(row.amount - row.fat_weight),
    },
    other_solids_average: {
        headerName: 'OS %',
        field: 'other_solids_average',
        minWidth: 100,
        flex: 1,
        type: 'string',
        valueGetter: ({ row }) => formatFloat(row.other_solids_average),
    },
    other_solids_weight: {
        headerName: 'OS (lbs)',
        field: 'other_solids_weight',
        minWidth: 100,
        flex: 1,
        type: 'string',
        valueGetter: ({ row }) => formatFloat(row.other_solids_weight),
    },
};
